module.exports = __webpack_public_path__ + "static/media/plaque_formation20.6a5849db.png";